/*
		dom.js,
			DOM helpers.
 */

var b = require('./base.js');

var DOM = {
	Div: function(par, abs, show) {
		var div = document.createElement("div");
		if(! show)
			div.style.display = "none";		/* everything starts invisible */
		if(abs)
			div.style.position = "absolute";
		if(par)
			par.appendChild(div);
		return div;
	},

	Span: function(par, abs, show) {
		var span = document.createElement("span");
		if(! show)
			span.style.display = "none";		/* everything starts invisible */
		if(abs)
			span.style.position = "absolute";
		if(par)
			par.appendChild(span);
		return span;
	},

	place: function(el, x, y, w, h) {
		if(el.__place__)
			el.__place__(x, y, w, h);
		else {
			if(x != undefined)
				el.style.left = x + "px";
			if(y != undefined)
				el.style.top = y + "px";
			if(w != undefined)
				el.style.width = w + "px";
			if(h != undefined)
				el.style.height = h + "px";
		}
	},

	getPos: function(obj) {
		var curleft = 0;
		var curtop = 0;

		if(obj.offsetParent) {
			while(obj.offsetParent) {
				curleft += obj.offsetLeft;
				curtop += obj.offsetTop;
				obj = obj.offsetParent;
			}
		}
		else if(obj.x) {
			curleft += obj.x;
			curtop += obj.y;
		}

		pos = {'x': curleft, 'y': curtop};
		return pos;
	},

	getScroll: function(obj) {
		var x = 0, y = 0;
		while(obj.parentNode) {
			x += obj.scrollLeft;
			y += obj.scrollTop;
			obj = obj.parentNode;
		}
		return {'x': x, 'y': y};
	},

	getObjClient: function(obj) {
		/* Gets the position of the given object in comparible coordinates to evt.client[XY] */
		var x = 0, y = 0;
		while(obj.offsetParent) {
			x += obj.offsetLeft;
			y += obj.offsetTop;
			x -= obj.scrollLeft;
			y -= obj.scrollTop;
			obj = obj.offsetParent;
		}
		return {'x': x, 'y': y};
	},

	getHeight: function(el) {
		return el.offsetHeight;
	},

	getWidth: function(el) {
		return el.offsetWidth;
	},

	show: function(el, visibility) {
		if(el.__show__)
			el.__show__();
		else {
			if(visibility)
				el.style.visibility = "";
			else
				el.style.display = "";
		}
		return el;
	},

	hide: function(el, visibility) {
		if(el.__hide__)
			el.__hide__();
		else {
			if(visibility)
				el.style.visibility = "hidden";
			else
				el.style.display = "none";
		}
		return el;
	},

	_creator: function(tagname) {
		return function(attrs) {
			el = document.createElement(tagname);
			b.copy(el, attrs);
			for(var i = 1; i < arguments.length; i++) {
				if(typeof(arguments[i]) == "string")
					el.appendChild(document.createTextNode(arguments[i]));
				else if(arguments[i].__element__)
					el.appendChild(arguments[i].__element__);
				else
					el.appendChild(arguments[i]);
			}
			return el;
		};
	},

	addBefore: function (el, child) {
		var idx = 0;
		var childElem = child;
		while ((childElem = childElem.previousSibling) != null)
			idx++;

		if (el.childNodes[idx] === child) {
			for (var i = 2; i < arguments.length; i++) {
				if (typeof(arguments[i]) == "string")
					el.insertBefore(document.createTextNode(arguments[i]), child);
				else if (arguments[i].__element__)
					el.insertBefore(arguments[i].__element__, child);
				else
					el.insertBefore(arguments[i], child);
			}
		}
	},

	addNodes: function(el) {
		for(var i = 1; i < arguments.length; i++) {
			if(typeof(arguments[i]) == "string")
				el.appendChild(document.createTextNode(arguments[i]));
			else if(arguments[i].__element__)
				el.appendChild(arguments[i].__element__);
			else
				el.appendChild(arguments[i]);
		}
		return el;
	},

	removeNodes: function(el) {
		for(var i = 1; i < arguments.length; i++) {
			if(arguments[i].__element__)
				el.removeChild(arguments[i].__element__);
			else
				el.removeChild(arguments[i]);
		}
		return el;
	},

	_creatorTxt: function(content) {
		return document.createTextNode(content);
	},

	style: function(attrs, el) {
		if(el.__element__)
			b.copy(el.__element__.style, attrs);
		else
			b.copy(el.style, attrs);
		return el;
	},

	setTxt: function(el, txt) {
		if(el.__element__)
			el = el.__element__;
		if(el.firstChild)
			el.firstChild.data = txt;
		else
			el.appendChild(document.createTextNode(txt));
	},

	getTxt: function(el) {
		if(el.__element__)
			el = el.__element__;
		if(el.firstChild)
			return el.firstChild.data;
		else
			return "";
	},

	childByType: function(el, typ) {
		if(el.__element__)
			el = el.__element__;
		for(var child = el.firstChild; child; child = child.nextSibling) {
			if(child.tagName == typ)
				return child;
		}
		return null;
	},

	isParent: function (parent, child) {
		var node = child.parentNode;
		while (node != null) {
			if (node == parent) {
				return true;
			}
			node = node.parentNode;
		}
		return false;
	},

	childrenByType: function(el, typ) {
		if(el.__element__)
			el = el.__element__;
		var children = [];
		for(var child = el.firstChild; child; child = child.nextSibling) {
			if(child.tagName == typ)
				children.push(child);
		}
		return children;
	},

	styleDiv: {},

	setSelectText: function(el, value) {
		for(var i = 0; i < el.length; i++) {
			if(el.options[i].text == value) {
				el.selectedIndex = i;
				return;
			}
		}
	},

	setSelectValue: function(el, value) {
		for(var i = 0; i < el.length; i++) {
			if(el.options[i].value == value) {
				el.selectedIndex = i;
				return;
			}
		}
	},

	getSelectText: function(el) {
		return el.options[el.selectedIndex].text;
	},

	getSelectValue: function(el) {
		return el.options[el.selectedIndex].value;
	},

	getSelect: function(el) {
		return DOM.getSelectValue(el) || DOM.getSelectText(el);
	},

	removeChildren: function(el){
		while (el.firstChild)
			el.removeChild(el.firstChild);
	},

	addClassName: function (el, clsname) {
		if (el.className.indexOf(clsname) == -1)
			el.className = el.className + ' ' + clsname;
	},

	removeClassName: function (el, clsname) {
		var idx = el.className.indexOf(clsname);
		if (idx != -1) {
			if (idx == 0)
				el.className = el.className.substring(clsname.length + 1, el.className.length)
			else if (idx + clsname.length == el.className.length)
				el.className = el.className.substring(0, idx - 1)
			else {
				start = el.className.substring(0, idx);
				end = el.className.substring(idx + clsname.length + 1, el.className.length)
				el.className = start + end;
			}
		}
	}
};

/* easy DOM creation functions */
DOM.SPAN = DOM._creator("span");
DOM.DIV = DOM._creator("div");
DOM.TABLE = DOM._creator("table");
DOM.FORM = DOM._creator("form");
DOM.THEAD = DOM._creator("thead");
DOM.TBODY = DOM._creator("tbody");
DOM.TR = DOM._creator("tr");
DOM.TD = DOM._creator("td");
DOM.TH = DOM._creator("th");
DOM.HR = DOM._creator("hr");
DOM.BR = DOM._creator("br");
DOM.UL = DOM._creator("ul");
DOM.LI = DOM._creator("li");
DOM.INPUT = DOM._creator("input");
DOM.TEXTAREA = DOM._creator("textarea");
DOM.TXT = DOM._creatorTxt;
DOM.P = DOM._creator("p");
DOM.SELECT = DOM._creator("select");
DOM.OPTION = DOM._creator("option");
DOM.IMG = DOM._creator("img");
DOM.LABEL = DOM._creator("label");
DOM.A = DOM._creator("a");
DOM.SUP = DOM._creator("sup");
DOM.BUTTON = DOM._creator("button");
DOM.IFRAME = DOM._creator("iframe");
DOM.I = DOM._creator("i");
DOM.H1 = DOM._creator("h1");
DOM.SMALL = DOM._creator("small");
module.exports = DOM;

/*
document.getElementsByClassName = function(className, parentElement) {
	var children = (parentElement || document.body).getElementsByTagName('*');
	var elements = [];
	var regex = new RegExp("(^|\\s)" + className + "(\\s|$)");
	children = b.$A(children);
	for(var i = 0; i < children.length; i++) {
		var child = children[i];
		if(child.className.match(regex))
			elements.push(child);
	}
	return elements;
}
*/

